export enum AutoLogoutDurationType {
    FIVE_MIN = "5",
    FIFTEEN = "15",
    THIRTY_MIN = "30",
    HOUR = "1",
    NEVER = "0",
}